export default __webpack_public_path__ + "static/media/tick.47696bd2.svg";